import React, { PureComponent } from 'react';
import { ConfigContext } from './ConfigContext';

function getDisplayName(Component) {
    return Component.displayName || Component.name || 'Component';
}

export default function injectConfig(WrappedComponent, options = {}) {
    const { propName = 'config' } = options;

    class InjectConfig extends PureComponent {
        static displayName = `injectConfig(${getDisplayName(WrappedComponent)})`
        static WrappedComponent = WrappedComponent

        render() {
            return (
                <ConfigContext.Consumer>
                    {(context) => (
                        <WrappedComponent
                            {...this.props}
                            {...{ [propName]: context.config }}
                        />
                    )}
                </ConfigContext.Consumer>
            );
        }
    }

    return InjectConfig;
}
